<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
    <FloatConsult></FloatConsult>
  </div>
</template>

<script>
import FloatConsult from './components/FloatConsult'
export default {
  name: 'App',
  components: { FloatConsult }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue